import React from "react"
import { Col, Row } from "react-bootstrap"
import { useFormikContext } from "formik"
import _ from "lodash"

import Pricing from "@/pricing"

import RateInputs from "./RateInputs"

// Edit Details takes two thirds of the row and Edit Rates the remaining third.
// A sheet whose editor is too wide for a third gets its own full-width row
// underneath the details instead.
const EditDetailsAndRates = ({ name = "ratesheet", hideRates = false, children }): JSX.Element => {
  const { values } = useFormikContext()
  const stacked = !hideRates && Pricing.editorNeedsFullWidth(_.get(values, name))

  return (
    <Row>
      <Col md={stacked ? 12 : 8} className="d-flex flex-column gap-2">
        {children}
      </Col>
      {!hideRates && (
        <Col md={stacked ? 12 : 4} className={stacked ? "mt-3" : "ms-n4"}>
          <h5 className="mb-0">Edit Rates</h5>
          <RateInputs name={name} />
        </Col>
      )}
    </Row>
  )
}

export default EditDetailsAndRates
